const data = {
  id: 1,
  title: 'Listen and choose the correct answer.',
  subTitle: 'Nghe và chọn đáp án đúng.',
  audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/1f0d8e98-a876-48a9-9886-6985619f4a68.mp3',
  question: 'Tony like ___',
  answers: [
    { id: 1, answer: 'planes', isCorrect: true },
    { id: 2, answer: 'boats', isCorrect: false },
    { id: 3, answer: 'robots', isCorrect: false },
  ],
  settings: {
    answers: {
      // direction: 'horizontal',
      direction: 'vertical',
    },
  },
};

export default data;
